import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { RadioButton, RadioButtonGroup, Dialog, FlatButton, TextField, Checkbox, MenuItem, DropDownMenu, IconButton, RaisedButton } from 'material-ui';
import { teams, availableAccess, permissionTypes } from './teamPermissionOptions';
import { updateUMProps, editUser, approveOrRejectUser as approveRejUser } from '../../../stores/settings/userManagement/actions';
import R from 'ramda';
import Select from 'react-select';
import UserInfo from './newUser/userInfo';
import SingleLocPermissions from './newUser/singleLocPermissions';
import MultiLocPermissions from './newUser/multiLocPermissions';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

class EditUserDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmDeleteUser: false,
    };
  }
  onCorporateLocCheck = () => {
    const {
      editedUser,
      updateProp,
    } = this.props;
    const corporateProfile = isNilOrEmpty(editedUser.profile)
    ? ['createLocation', 'read', 'write']
    : [];
    updateProp({
      editedUser: {
        ...editedUser,
        profile: corporateProfile,
      },
    });
  };
  render() {
    const {
      editUserDialogOpen,
      updateProp,
      editedUser = {},
      originalUser,
      updateUser,
      locations,
      deletingUser,
      updatingUser,
      viewBy,
      companyType,
      isSingleLoc,
      companyName,
      updateUserError,
      userId,
      approveOrRejectUser,
      approvingRejectingUser,
      isAccom,
      locAccess,
    } = this.props;

    const showLoc = !R.equals(companyType, 'Contractor') && !isSingleLoc;
    const editingSelf = userId === originalUser.userId;

    const locsUserHasEditAccessTo = locations.map(loc => {
      if (locAccess.some(access => access.locId === loc._id
        && access.admin.indexOf('write') > -1)) {
        return { ...loc, disabled: false };
      }
      return { ...loc, disabled: true };
    });
    const clearStore = () => {
      this.setState({ showConfirmDeleteUser: false });
      updateProp({ editUserDialog: false, editedUser: {}, originalUser: {} });
    };
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onTouchTap={() => clearStore()}
      />,
      <FlatButton
        label="Submit"
        secondary
        disabled={R.equals(originalUser, R.omit(['allLocsSelected'], editedUser)) ||
        R.isEmpty(editedUser.firstName) ||
        R.isEmpty(editedUser.lastName) ||
        R.isEmpty(editedUser.email) ||
        (
          editingSelf &&
          R.equals(originalUser.firstName, editedUser.firstName) &&
          R.equals(originalUser.lastName, editedUser.lastName) &&
          R.equals(originalUser.email, editedUser.email)
        ) ||
        deletingUser || updatingUser || !isNilOrEmpty(updateUserError)}
        onTouchTap={() => {
          const userRemovedLoc = R.path(['locAccess', 'length'], originalUser) !== R.path(['locAccess', 'length'], editedUser);
          const removedLocs = originalUser.locAccess.filter(loc => !R.contains(loc.locId, R.pluck('locId')(editedUser.locAccess)));
          const addRemovedLocsToEditedUser = userRemovedLoc ? R.merge(editedUser, { removedLocs }) : editedUser;
          updateUser(R.merge(addRemovedLocsToEditedUser, { viewBy }));
          clearStore();
        }}
      />,
    ];
    return (
      <Dialog
        title={`Editing User: ${R.propOr('', 'firstName', originalUser)} ${R.propOr('', 'lastName', originalUser)}`}
        actions={actions}
        modal
        open={editUserDialogOpen}
        autoScrollBodyContent
        bodyStyle={{ minHeight: '300px' }}
      >
        {
          !isNilOrEmpty(updateUserError) && !updatingUser &&
          <div style={{ color: 'red', fontWeight: 600 }}>There's an error in updating the user: {updateUserError}.</div>
        }
        {editingSelf && <div style={{ fontWeight: 600, margin: '16px' }}>Note: You cannot edit your own access, only your name and email.</div>}
        <UserInfo
          editUserInfo={(userInfo) => updateProp({ editedUser: { ...editedUser, ...userInfo } })}
          {...editedUser}
        />
        <div style={{ display: editingSelf ? 'none' : 'block' }}>
          {
            !isNilOrEmpty(R.propOr('', 'status', editedUser)) &&
            <div style={{ margin: '10px 0 15px 0', display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center', width: '100%' }}>
              <div style={{ width: '20%' }}>Email Status</div>
              <div style={{ display: 'flex', flexDirection: 'row', width: '75%' }}>
                {
                  editedUser.status === 'pending' ?
                    <div style={{ display: 'inline-block' }}>
                      <span style={{ marginRight: '10px' }}>Pending for Approval: </span>
                      <RaisedButton
                        label="Approve"
                        disabled={approvingRejectingUser}
                        secondary
                        onTouchTap={() => {
                          approveOrRejectUser(editedUser, 'approve')
                            .then(res => {
                              const updatedUser = R.pathOr([], ['payload', 'usersArray'], res)
                                .filter(obj => obj._id === editedUser.userId);
                              updateProp({
                                editedUser: R.merge(editedUser, {
                                  status: R.pathOr('pending', [0, 'status'], updatedUser),
                                }),
                              });
                            });
                        }}
                        style={{ marginRight: '10px' }}
                      />
                      <RaisedButton
                        label="Reject"
                        disabled={approvingRejectingUser}
                        primary
                        onTouchTap={() => {
                          approveOrRejectUser(editedUser, 'reject')
                            .then(res => {
                              const updatedUser = R.pathOr([], ['payload', 'usersArray'], res)
                                .filter(obj => obj._id === editedUser.userId);
                              updateProp({
                                editedUser: R.merge(editedUser, {
                                  status: R.pathOr('pending', [0, 'status'], updatedUser),
                                }),
                              });
                            });
                        }}
                      />
                    </div> :
                    <div style={{ fontWeight: 'bold' }}>
                      {R.call(R.cond([
                        [R.equals('pending'), R.always('Pending for Approval')],
                        [R.equals('approved'), R.always(editedUser.confirmed_at ? 'Email Confirmed' : 'Email Not Confirmed')],
                        [R.equals('rejected'), R.always('Rejected')],
                      ]), editedUser.status)}
                    </div>
                }
              </div>
            </div>
          }
          {
            !showLoc
              ? <SingleLocPermissions
                isAccom={isAccom}
                userName={`${R.pathOr('', ['firstName'], editedUser)} ${R.pathOr('', ['lastName'], editedUser)}`}
                onLocSelection={(selectedLocs) => updateProp({
                  editedUser: {
                    ...editedUser,
                    // for single location we will sync the loc access with the corporate access
                    ...selectedLocs[0],
                    locAccess: R.isEmpty(editedUser.locAccess) ? [] : selectedLocs,
                  } })}
                // if locAccess is empty, it's a buyer
                selectedLocs={R.isEmpty(editedUser.locAccess) ? [editedUser] : editedUser.locAccess}
                corporateProfileAccess={!isNilOrEmpty(editedUser.profile)}
                showCorporateProfileRadioButtons={R.contains('write', this.props.corporateAccess)}
                onCorporateLocCheck={this.onCorporateLocCheck}
              />
              :
              (<MultiLocPermissions
                isAccom={isAccom}
                isSingleLoc={isSingleLoc}
                locations={locsUserHasEditAccessTo}
                userName={`${R.pathOr('', ['firstName'], editedUser)} ${R.pathOr('', ['lastName'], editedUser)}`}
                onLocSelection={(selectedLocs) => updateProp({ editedUser: { ...editedUser, locAccess: selectedLocs } })}
                selectedLocs={(editedUser.locAccess || []).map(obj => ({ ...obj, value: obj.locId, label: obj.property_name }))}
                onlyHasAccessToOneLoc={locsUserHasEditAccessTo.length === 1}
                corporateProfileAccess={!isNilOrEmpty(editedUser.profile)}
                showCorporateProfileRadioButtons={R.contains('write', this.props.corporateAccess)}
                onCorporateLocCheck={this.onCorporateLocCheck}
                allLocsSameTeamAndLocs={false}
              />)
          }
        </div>
      </Dialog>
    );
  }
}

EditUserDialog.propTypes = {
  editUserDialogOpen: PropTypes.bool,
  updateProp: PropTypes.func,
  editedUser: PropTypes.object,
  originalUser: PropTypes.object,
  locations: PropTypes.array,
  updateUser: PropTypes.func,
  deletingUser: PropTypes.bool,
  updatingUser: PropTypes.bool,
  viewBy: PropTypes.string,
  companyType: PropTypes.string,
  isSingleLoc: PropTypes.bool,
  companyName: PropTypes.string,
  updateUserError: PropTypes.string,
  userId: PropTypes.string,
  approveOrRejectUser: PropTypes.func,
  approvingRejectingUser: PropTypes.bool,
  isAccom: PropTypes.bool,
  corporateAccess: PropTypes.array,
  locAccess: PropTypes.array,
};

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateUMProps(...args)),
  updateUser: (...args) => dispatch(editUser(...args)),
  approveOrRejectUser: (user, action) => dispatch(approveRejUser(user, action)),
});

const mapStateToProps = ({ userManagement, user }) => ({
  userId: user.get('id'),
  editUserDialogOpen: userManagement.get('editUserDialog'),
  editedUser: userManagement.get('editedUser').toJS(),
  originalUser: userManagement.get('originalUser').toJS(),
  locations: user.get('allLocations'),
  deletingUser: userManagement.get('deletingUser'),
  updatingUser: userManagement.get('updatingUser'),
  viewBy: userManagement.get('viewBy'),
  companyType: user.getIn(['user', 'type']),
  isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
  companyName: user.getIn(['company', 'companyName']),
  isAccom: user.getIn(['company', 'productType']) === 'Accommodation',
  updateUserError: userManagement.get('updateUserError'),
  approvingRejectingUser: userManagement.get('approvingRejectingUser'),
  corporateAccess: user.get('corporateAccess'),
  locAccess: user.get('locAccess'),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditUserDialog);



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/editUserDialog.jsx